import React from 'react';
import PropTypes from 'prop-types';

const IconDiscountOutline = ({
  className = '',
  color = '#737373',
  width = '14px',
  height = '20px',
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    role="img"
    viewBox="0 0 21 30"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M 20.3347 10.2929 C 20.3347 9.1632 19.9582 8.159 19.205 7.4059 L 12.9289 1.1297 C 11.4226 -0.3766 8.9121 -0.3766 7.4059 1.1297 L 1.1297 7.4059 C 0.3766 8.159 0 9.1632 0 10.1674 V 26.1088 C 0 28.2427 1.7573 30 3.8912 30 H 16.4435 C 18.5774 30 20.3347 28.2427 20.3347 26.1088 V 10.2929 Z M 10.1674 2.3849 C 11.4226 2.3849 12.3013 3.3891 12.3013 4.5188 C 12.3013 5.7741 11.2971 6.6527 10.1674 6.6527 C 8.9121 6.6527 8.0335 5.6486 8.0335 4.5188 C 8.0335 3.3891 8.9121 2.3849 10.1674 2.3849 Z M 3.0126 16.8201 C 3.0126 14.6862 4.1423 13.3055 5.7741 13.3055 C 7.5314 13.3055 8.5356 14.8117 8.5356 16.8201 C 8.5356 18.8285 7.4059 20.3348 5.782 20.332 C 4.1423 20.3348 3.0126 18.954 3.0126 16.8201 Z M 5.8996 24.8535 L 12.9289 13.431 H 14.5607 L 7.5314 24.8535 H 5.8996 Z M 14.4351 25.1046 C 12.8033 25.1046 11.6737 23.5984 11.6737 21.59 C 11.6737 19.4561 12.8033 18.0753 14.4351 18.0753 C 16.1925 18.0753 17.1967 19.5816 17.1967 21.59 C 17.3222 23.5984 16.1925 25.1046 14.4351 25.1046 Z M 5.782 14.088 C 7.24 14.088 7.842 15.229 7.842 16.845 C 7.906 18.684 6.987 19.603 5.782 19.634 C 4.546 19.603 3.817 18.81 3.754 16.845 c 0 -1.711 0.475 -2.757 2.028 -2.757 Z M 14.434 18.81 C 15.766 18.779 16.558 19.983 16.463 21.473 C 16.558 23.057 16.083 24.325 14.434 24.325 C 12.913 24.325 12.438 22.962 12.438 21.599 C 12.374 20.3 12.945 18.81 14.434 18.81 Z"
      stroke={color}
      strokeWidth="0.65"
    />
  </svg>
);

IconDiscountOutline.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default IconDiscountOutline;
